export default __webpack_public_path__ + "static/media/logo.c375edd2.png";